export const DEFAULT_DRAGGED_ITEMS_COUNT = 1
